<template>
    <div>
        <div v-if="hasRead(slug) === 'read'" class="status-badge status-read">
            <span class="status-label">Read</span>
            <global-svg type="tick-single" width="7px" height="7px" color="#FFF"></global-svg>
        </div>
        <div v-else-if="hasRead(slug) === 'skimmed'" class="status-badge status-skimmed">
            <span class="status-label">Skimmed</span>
            <global-svg type="skimmed-single" width="7px" height="7px" color="#FFF"></global-svg>
        </div>
        <div v-else-if="hasRead(slug) === 'glanced'" class="status-badge status-glanced">
            <span class="status-label">Glanced</span>
            <global-svg type="glanced-single" width="7px" height="7px" color="#FFF"></global-svg>
        </div>
    </div>
</template>

<script>
    import { Mixins } from '@/components/Grid/mixins'

    export default {
        props: ['slug'],
        mixins: [Mixins],
    }
</script>

<style lang="scss" scoped>
    @import '~styles/_variables';

    .status-badge {
        display: flex;
        font-family: $ff-tag;
        font-size: 9px;
        font-weight:  bold;
        color: $white-primary;
        padding: 4px 7px;
        border-radius: $border-radius;

        .svg-wrapper {
            padding-left: 5px;
            padding-bottom: 1px;
        }
    }

    .status-read {
        background: $highlight-read;
    }

    .status-skimmed {
        background: $highlight-skimmed;
    }

    .status-glanced {
        background: $highlight-glanced;
    }

</style>